import {HttpClient} from '@angular/common/http';
import {ServiceBase} from '../base/service.base';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {User} from '../../generated/graphql';

@Injectable({
    providedIn: 'root'
})
export class UserService extends ServiceBase {
    isAuthenticated = false;

    private userDataSource = new BehaviorSubject<User>(new User());
    user = this.userDataSource.asObservable();

    private notificationDataSource = new BehaviorSubject<Notification[]>([]);
    notification = this.notificationDataSource.asObservable();

    private tokenDataSource = new BehaviorSubject<string>(null);
    token = this.tokenDataSource.asObservable();

    constructor(http: HttpClient) {
        super(http);
    }

    updateToken(token: string) {
        localStorage.setItem('token', token);
    }

    getToken(): string {
        return this.tokenDataSource.value;
    }

    getUserLocal(): User {
        return this.userDataSource.value;
    }

    updateUser(user: User, tokenChanged: boolean = false, t: string = null) {
        if (tokenChanged) {
            this.updateToken(t);
            this.tokenDataSource.next(t);
        }
        this.userDataSource.next(user);
    }

    updateUserPre(user: User) {
        this.userDataSource.next(user);
    }

    getStatusAuthenticated() {
        const t = localStorage.getItem('token') as string;
        if (t != null && typeof t !== 'undefined') {
            if (this.getToken() == null || typeof this.getToken() !== 'undefined') {
                this.tokenDataSource.next(t);
            }
            return true;
        } else {
            return false;
        }
    }

    search(page, filter) {
        const url = `${this.BASE_URL}/user/search/${page}`;
        return this.http.post(url, filter);
    }

    create(model) {
        const url = `${this.BASE_URL}/user`;
        return this.http.post(url, model);
    }

    update(model) {
        const url = `${this.BASE_URL}/user`;
        return this.http.put(url, model);
    }

    getNotification() {
        const url = `${this.BASE_URL}/user/notification`;
        this.http.get(url).subscribe({
            next: data => {
                this.notificationDataSource.next(data as Notification[]);
            }, error: err => {
            }
        });
    }

    updateNotification(id) {
        const url = `${this.BASE_URL}/user/notification/${id}`;
        return this.http.put(url, {});
    }

    uploadFile(file, urlParameter) {
        const url = `${this.BASE_URL}${urlParameter}`;
        return new Observable((observer) => {
            const formData: FormData = new FormData();
            const xhr: XMLHttpRequest = new XMLHttpRequest();
            if (file != null) {
                formData.append('file', file, file.name);
            }
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        observer.next(JSON.parse(xhr.response));
                        observer.complete();
                    } else {
                        observer.error(xhr.response);
                    }
                }
            };
            xhr.upload.onprogress = (event) => {
                const progress = Math.round(event.loaded / event.total * 100);
                console.log(progress);
            };
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.getToken());
            xhr.send(formData);
        });
    }
}
